import { render, staticRenderFns } from "./press-list.vue?vue&type=template&id=762c0b3e&scoped=true"
import script from "./press-list.vue?vue&type=script&lang=js"
export * from "./press-list.vue?vue&type=script&lang=js"
import style0 from "./press-list.vue?vue&type=style&index=0&id=762c0b3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "762c0b3e",
  null
  
)

export default component.exports